import React from 'react';
import Container from '../Container';
import companies from '../../data/companies';
import './Timeline.css';

const Timeline = () => {
  return (
    <div className="timeline">
      {companies.map((company, i) =>
        <Container key={i} company={company} />
      )}
    </div>
  )
}

export default Timeline;
